<template>
  <div>
    <div :class="$style.disabledContainer" v-if="disabled" v-tooltip.top-center="disabled && tooltipMessage">
      <button
        :disabled="disabled"
        :class="$style.newBaseButton"
        :style="{ padding, fontSize, margin }"
      >
        <slot />
      </button>
    </div>
    <button
      @click.prevent="click"
      v-if="!disabled"
      :disabled="disabled"
      :class="$style.newBaseButton"
      :style="{ padding, fontSize, margin }"
    >
      <slot />
    </button>
  </div>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    click: {
      type: Function,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: Boolean,
      default: false
    },
    tooltipMessage: {
      type: String,
      default: ''
    },
    padding: {
      type: String,
      default: '.375rem 1.5rem'
    },
    fontSize: {
      type: String,
      default: '.8rem'
    },
    margin: {
      type: String,
      default: '0 0 1rem 0'
    }
  }
}
</script>

<style lang="scss" module>
  @import '@design';

  .disabledContainer {
    display: inline-block;
  }

  .newBaseButton {
    cursor: pointer;
    color: $black;
    background-color: $new-base-button-bg-color;
    border-color: $new-base-button-bg-color;
    border-radius: 4px;
    font-family: Avenir;
    font-weight: 500;
    transition: .3s ease all;

    &:hover {
      background-color: $new-base-button-bg-color-hover;
      border-color: $new-base-button-bg-color;
    }

    &:disabled {
      background-color: $new-base-button-bg-color-disabled;
      border-color: $new-base-button-bg-color-disabled;
      color: $new-base-button-color-disabled;
      cursor: not-allowed;
    }
  }
</style>
